<div
  class="file-preview bg-pays-subtle rounded-1"
  [class.bg-pays-subtle-2]="isActive()">
  <div class="row align-items-center">
    <button
      type="button"
      class="col btn-reset pe-0"
      (click)="onViewReceipt()">
      <div class="row align-items-center">
        <div class="col-auto">
          <img
            [ngSrc]="fileTypeIcon() ?? ''"
            height="34"
            width="25"
            alt="file icon" />
        </div>
        <div class="col text-sm">
          <div class="row">
            <div class="col-auto">
              <div class="">{{ receipt().name }}</div>
            </div>
            <div class="col-auto">
              @if (receipt().status !== TransactionReceiptStatus.UPLOADED) {
                <app-status-badge
                  [value]="receipt().status"
                  [department]="statusBadgeDepartments.RECEIPTS"></app-status-badge>
              }
            </div>
          </div>
          <span class="text-muted">{{ receipt().size | fileSize }}</span>
        </div>
        <div class="col-auto">
          <div class="btn-action bg-none">
            <i class="text-secondary pays-svg-icon ic-eye"></i>
          </div>
        </div>
      </div>
    </button>
    <div class="col-auto ms-auto">
      <button
        type="button"
        class="btn-action bg-none"
        title="Download receipt"
        (click)="downloadReceipt()">
        <i class="iconoir-download"></i>
      </button>
      @if (!hideDelete()) {
        <button
          type="button"
          class="btn-action bg-none"
          (click)="deleteReceipt()">
          <i class="pays-icon ic-bin size-1"></i>
        </button>
      }
    </div>
  </div>
</div>
